export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M6 3.75a.25.25 0 00-.25.25v16c0 .138.112.25.25.25h12a.25.25 0 00.25-.25V6.75H16a.75.75 0 01-.75-.75V3.75H6zM4.25 4c0-.966.784-1.75 1.75-1.75h10a.75.75 0 01.53.22l3 3c.141.14.22.331.22.53v14A1.75 1.75 0 0118 21.75H6A1.75 1.75 0 014.25 20V4z\" fill=\"#6F7488\"/><path d=\"M8.018 14.25v-3.592h-1.3v-.635h3.36v.635H8.774v3.592h-.756zM10.125 14.25l1.38-2.13v-.009l-1.368-2.088h.893l.982 1.59h.032l.978-1.59h.85l-1.415 2.109v.009l1.392 2.109h-.873l-1-1.556h-.026l-.999 1.556h-.826zM15.226 14.25v-3.592h-1.3v-.635h3.36v.635h-1.304v3.592h-.756z\" fill=\"#6F7488\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};